'use client';
import CarDisplayCardClient from '@/components/shared/car-details-card/car-details-car-client.component';
import { useTranslation } from '@/hook';
import { useRouter } from 'next/navigation';
import React, { useEffect } from 'react';
import styles from './styles.module.scss';
import { isValidUUid } from '@/utils/uuidV4.util';
import { TFebDiscounts } from '@/api-requests/feb-discounts.apis';
import { CarDetailsType } from '@/types';
import { GetCarListing } from '@/types/cars.types';
import { getCarCardLocale } from '@/utils';
import { AVAILABLE_LANGUAGES } from '@/constants';

export default function CarsGrid({
    similarCars,
    carDetails,
    febDiscounts,
}: {
    similarCars: GetCarListing;
    carDetails: CarDetailsType;
    febDiscounts: TFebDiscounts;
}) {
    const { t, i18n } = useTranslation();
    const router = useRouter();
    useEffect(() => {
        if (carDetails) {
            if (carDetails.isPublished) {
                if (isValidUUid(carDetails.id)) {
                    router.push(
                        `/${i18n.language}/car-details/${carDetails.id}`
                    );
                }
            }
        }
    }, []);
    const imgs = [
        {
            image: 'https://fastly-production.24c.in/hello-ar/dev/1920/912028f8-bc14-4921-bf2b-10b7dadc8738/f8254072-57fb-4310-ab4a-05a932b8239f/1.jpg',
        },
        {
            image: 'https://fastly-production.24c.in/hello-ar/dev/1920/912028f8-bc14-4921-bf2b-10b7dadc8738/f8254072-57fb-4310-ab4a-05a932b8239f/13.jpg',
        },
        {
            image: 'https://fastly-production.24c.in/hello-ar/dev/1920/912028f8-bc14-4921-bf2b-10b7dadc8738/f8254072-57fb-4310-ab4a-05a932b8239f/24.jpg',
        },
        {
            image: 'https://fastly-production.24c.in/hello-ar/dev/1920/912028f8-bc14-4921-bf2b-10b7dadc8738/f8254072-57fb-4310-ab4a-05a932b8239f/41.jpg',
        },
        {
            image: 'https://fastly-production.24c.in/hello-ar/dev/1920/912028f8-bc14-4921-bf2b-10b7dadc8738/f8254072-57fb-4310-ab4a-05a932b8239f/44.jpg',
        },
        {
            image: 'https://fastly-production.24c.in/hello-ar/dev/1920/912028f8-bc14-4921-bf2b-10b7dadc8738/f8254072-57fb-4310-ab4a-05a932b8239f/33.jpg',
        },
    ];
    const carCardLocalizations = getCarCardLocale();

    return (
        <div>
            <div className={styles.similarCarsContainer}>
                {similarCars?.data
                    ?.slice(0, 12)
                    .map((item: any, index: number) => (
                        <CarDisplayCardClient
                            febDiscount={febDiscounts[item.id] || 0}
                            carCardLocalizations={carCardLocalizations}
                            lang={AVAILABLE_LANGUAGES[i18n.language]}
                            id={item.id}
                            key={item.id}
                            cardTitle={`${t(item.make)} ${item.model} ${
                                item.year
                            }`}
                            carName={item.sfVehicleName}
                            trim={item.trim}
                            installmentPrice={item?.installmentPrice}
                            totalPrice={item.sylndrSellingPrice}
                            kilometers={item.kilometers}
                            year={item.year}
                            transmission={item.transmission}
                            images={
                                item?.images.length !== 0 ? item?.images : imgs
                            }
                            isReserved={item.isReserved}
                            make={item.make}
                            model={item.model}
                            sourceScreen={'Car Profile'}
                            appliedFilter={false}
                            appliedSort={false}
                            position={index + 1}
                            isPurchaseInProgress={item.isPurchaseInProgress}
                            discountPrice={item?.discountPrice}
                            isNewlyAdded={item?.isNewlyAdded}
                        />
                    ))}
            </div>
        </div>
    );
}
